import classNames from 'classnames';
import type { AppGarage } from '$page-router/api/getGaragesByLatLong';
import styles from './index.module.scss';

interface GarageFooterSectionProps {
  readonly bookingsNumber: AppGarage['bookingsNumber'];
  readonly yearsInBusinessNumber: AppGarage['yearsInBusinessNumber'];
  readonly translations: {
    readonly bookingsNumberText?: string;
    readonly yearsInBusinessText?: string;
  };
}

export function GarageFooterSection({
  bookingsNumber,
  yearsInBusinessNumber,
  translations: { bookingsNumberText, yearsInBusinessText },
}: GarageFooterSectionProps): JSX.Element {
  return (
    <div className={classNames(styles.GarageFooterSection)}>
      {bookingsNumber && bookingsNumber > 0 && bookingsNumberText && (
        <div className={styles.BookingsNumberSection}>
          <div>{bookingsNumber}+</div>
          <div>{bookingsNumberText}</div>
        </div>
      )}

      {yearsInBusinessNumber && yearsInBusinessText && (
        <div className={styles.YearsInBusinessSection}>
          <div>{yearsInBusinessNumber}+</div>
          <div>{yearsInBusinessText}</div>
        </div>
      )}
    </div>
  );
}

GarageFooterSection.displayName = 'GarageFooterSection';
